import * as React from 'react';
/**
 *
 * Original name: activity
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=58517%3A219
 *
 */
export const ActivityPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M50.37 27H38V7.625L12.63 37H25v19.375L50.37 27Zm-29 6L34 18.375V31h7.63L29 45.625V33h-7.63Z", fill: "currentColor" })));
